module.exports = __webpack_public_path__ + "media/src/components/Footer/LicenseSection/payment-options-47959892813e75fb7e4962733fb9a732.png";